import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { brandForLocation, rememberProduct, productFromSearch } from './productIdentity';
export { brandForPath } from './productIdentity';

export function clickInstallPath(path) {
  return /^\/c\//.test(path) ? path.split('/').slice(0, 3).join('/') : '/';
}

export default function BrandMetadata() {
  const location = useLocation();
  const path = location.pathname === '/admin' ? location.state?.from?.pathname || location.pathname : location.pathname;
  const isAdmin = /^\/admin(?:\/|$)/.test(location.pathname);
  const explicitEntry = Boolean(productFromSearch(location.search) || productFromSearch(location.state?.from?.search));
  const brand = brandForLocation(location, window.location.hostname);
  useEffect(() => {
    if (isAdmin) rememberProduct(brand, explicitEntry);
    document.title = brand.toUpperCase();
    const changed = [];
    const update = (rel, href) => {
      let link = document.querySelector(`link[rel="${rel}"]`);
      const created = !link;
      if (!link) { link = document.createElement('link'); link.rel = rel; document.head.appendChild(link); }
      const previous = link.getAttribute('href');
      changed.push(() => { if (created) link.remove(); else if (previous === null) link.removeAttribute('href'); else link.setAttribute('href', previous); });
      link.setAttribute('href', href);
    };
    update('icon', `/static/favicon-be-20261016/${brand}/icon-32.png`);
    update('apple-touch-icon', `/static/favicon-be-20261016/${brand}/apple-touch-icon.png`);
    // Keep existing installation identities: restaurant root for ordering, / for other journeys.
    let objectUrl;
    if (brand === 'beclick' && typeof URL.createObjectURL === 'function') {
      objectUrl = URL.createObjectURL(new Blob([JSON.stringify({ name: 'BECLICK', short_name: 'BECLICK', id: clickInstallPath(path), start_url: clickInstallPath(path), scope: '/', display: 'standalone', icons: [...[192, 512].map(size => ({ src: `${window.location.origin}/static/favicon-be-20261016/beclick/icon-${size}.png`, sizes: `${size}x${size}`, type: 'image/png', purpose: 'any' })), { src: `${window.location.origin}/static/favicon-be-20261016/beclick/maskable-512.png`, sizes: '512x512', type: 'image/png', purpose: 'maskable' }] })], { type: 'application/manifest+json' }));
      update('manifest', objectUrl);
    } else if (brand !== 'beclick') update('manifest', (brand === 'beresto' ? '/static/favicon-be-20261016/beresto/app.webmanifest' : brand === 'bekiosk' ? '/manifest.json' : ['/pad', '/cuisine', '/etat'].includes(path) ? `/becaisse-${path.slice(1)}.webmanifest` : `/${brand}.webmanifest`) + '?v=be-only-20261016');
    return () => { changed.reverse().forEach(restore => restore()); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path, brand, isAdmin, explicitEntry]);
  return null;
}
